import { __rest } from "tslib";
import React, { Component } from 'react';
import { Tabs, Row, Col } from 'antd';
import { CarPosition, SelectQuery, UnitSearch, StickyContainer, ContentContainer } from '@/components';
import AuthorizedTab from '@/components/Auth/authTab';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { WaitAuction, PreviewCar, InAuctionCar, WaitDeal, FlowAuctionCar, DealEnd, ReturnShop, WinBiddingCar, TradingDelivery, } from './_components/index';
const mapStateToProps = (rootState) => ({
    carState: rootState.carState,
});
class CarManage extends Component {
    constructor(props) {
        super(props);
        this.ref = {};
        this.state = {
            searchData: {
                unitData: {},
            },
            activeKey: undefined,
            queryList: [
                {
                    label: 'VIN码',
                    key: 'vin',
                },
                {
                    label: '车牌号',
                    key: 'license',
                },
                {
                    label: '卖家经销商电话',
                    key: 'sellerPhone',
                },
            ],
            tabList: [
                {
                    key: 'awaitAuctionCount',
                    label: '待入场',
                    TabComponent: WaitAuction,
                    ref: React.createRef(),
                    allow: 'psgjb-carpenddrc-enter',
                },
                {
                    key: 'previewNum',
                    label: '预展中',
                    TabComponent: PreviewCar,
                    ref: React.createRef(),
                    allow: 'psgjb-carpendyuzhan-enter',
                },
                {
                    key: 'auctionNum',
                    label: '拍卖中',
                    TabComponent: InAuctionCar,
                    ref: React.createRef(),
                    allow: 'psgjb-carpendjingpai-enter',
                },
                {
                    key: 'endNum',
                    label: '结标中',
                    TabComponent: WaitDeal,
                    ref: React.createRef(),
                    allow: 'psgjb-cartransacpend-enter',
                },
                {
                    key: 'winningNumber',
                    label: '中标',
                    TabComponent: WinBiddingCar,
                    ref: React.createRef(),
                    allow: 'psgjb-carpendzhongbiao-enter',
                },
                {
                    key: 'dealNumber',
                    label: '成交交付中',
                    TabComponent: TradingDelivery,
                    ref: React.createRef(),
                    allow: 'psgjb-carpendcjjfz-enter',
                },
                {
                    key: 'completionOfTransactionNumber',
                    label: '交易完结',
                    TabComponent: DealEnd,
                    ref: React.createRef(),
                    allow: 'psgjb-carpendcjjywj-enter',
                },
                {
                    key: 'passedInCount',
                    label: '流拍',
                    TabComponent: FlowAuctionCar,
                    ref: React.createRef(),
                    allow: 'psgjb-carfail-enter',
                },
                {
                    key: 'returnCount',
                    label: '退回门店',
                    TabComponent: ReturnShop,
                    ref: React.createRef(),
                    allow: 'psgjb-cartradend-enter',
                },
            ],
            maxShowNum: 9999,
        };
        this.changeTab = this.changeTab.bind(this);
        this.onChangeSearch = this.onChangeSearch.bind(this);
    }
    componentDidMount() {
        window.addEventListener('resize', () => {
            this.forceUpdate();
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', () => {
        });
        dispatch.carState.resetState({});
    }
    onChangeSearch() {
        const _a = this.state.searchData, { unitData } = _a, searchData = __rest(_a, ["unitData"]);
        const { tabList, activeKey } = this.state;
        const activeKeyStr = activeKey || tabList[0].key;
        const $trigger = this.ref[activeKeyStr].current;
        $trigger.searchData(Object.assign(Object.assign({}, searchData), unitData));
        dispatch.carState.SET_STATE({
            globalSearch: Object.assign(Object.assign({}, searchData), unitData),
        });
        dispatch.carState.getEveryStateCarNum({});
    }
    changeTab(activeKey) {
        dispatch.carState.resetTableData();
        this.setState({
            activeKey,
        });
    }
    render() {
        const { queryList, tabList, activeKey, maxShowNum, searchData } = this.state;
        const { searchNum } = this.props.carState;
        const { unitData } = searchData, otherSearch = __rest(searchData, ["unitData"]);
        const allowList = tabList.map((tab) => tab.allow);
        return (<>
        <StickyContainer>
          <Row gutter={16}>
            <Col span={4}>
              <CarPosition CascaderProps={{
            className: 'width-100',
            placeholder: '全部车辆所在地',
        }} onChange={(val) => {
            const searchData = this.state.searchData;
            const [provinceCode, cityCode] = val || ['', ''];
            this.setState({
                searchData: Object.assign(Object.assign({}, searchData), { provinceCode,
                    cityCode }),
            }, () => {
                this.onChangeSearch();
            });
        }}/>
            </Col>
            <Col span={4}>
              <SelectQuery placeholder={'选择卖家经销商名称'} labelInValue={false} onChange={(val) => {
            const searchData = this.state.searchData;
            this.setState({
                searchData: Object.assign(Object.assign({}, searchData), { sellerCode: val }),
            }, () => {
                this.onChangeSearch();
            });
        }}/>
            </Col>
            <Col span={6}>
              <UnitSearch queryList={queryList} onChange={(val) => {
            const searchData = this.state.searchData;
            const unitSearch = {};
            if (val) {
                const [searchKey, searchContent] = val.split('_');
                unitSearch[searchKey] = searchContent;
            }
            this.setState({
                searchData: Object.assign(Object.assign({}, searchData), { unitData: unitSearch }),
            }, () => {
                this.onChangeSearch();
            });
        }}/>
            </Col>
          </Row>
          <AuthorizedTab className={'tab_custom_style'} style={{
            marginTop: '30px',
        }} activeKey={activeKey} onTabClick={this.changeTab} allow={allowList}>
            {tabList.map(({ key, label, TabComponent, ref }) => {
            if (!this.ref[key]) {
                this.ref[key] = ref;
            }
            const tabNum = searchNum[key] || 0;
            return (<Tabs.TabPane key={key} tab={(<>
                        <span>{label}</span>
                        <span className={'tip_num'}>
                          ({tabNum > maxShowNum ? `${maxShowNum}+` : tabNum})
                        </span>
                      </>)}/>);
        })}
          </AuthorizedTab>
        </StickyContainer>
        <ContentContainer>
          {tabList.map(({ key, label, TabComponent, ref, num }) => {
            if (!this.ref[key]) {
                this.ref[key] = ref;
            }
            return (activeKey || tabList[0].key) === key ? (<TabComponent search={Object.assign(Object.assign({}, otherSearch), unitData)} key={key} ref={ref} triggerNum={(newNum) => {
                tabList.forEach((item) => {
                    if (item.key === key) {
                        item.num = newNum;
                    }
                });
                this.setState({
                    tabList,
                });
            }}/>) : null;
        })}
        </ContentContainer>
      </>);
    }
}
export default connect(mapStateToProps)(CarManage);
